import type * as React from 'react';
import type { IconProps } from './types';

const TextLinesIcon = (props: IconProps & { ref?: React.Ref<SVGSVGElement> }) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path d="M3 6H21M3 10H21M3 14H21M3 18H16" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};

export { TextLinesIcon };
